export const ERROR = 'ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
